"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = invalidASCII;
// This regex finds any character outside the range between (ASCII 32) and (ASCII 127)
var INVALID_ASCII_REGEX = /[^\x20-\x7f]/;

function invalidASCII(string) {
  return INVALID_ASCII_REGEX.test(string);
}